"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _ = require("_");

function _default(url) {
  var tokens = url.split('/');
  var tokensAsNumbers = tokens.map(function (token) {
    return parseInt(token, 10);
  });
  return (0, _.last)((0, _.filter)(tokensAsNumbers, function (token) {
    return !isNaN(token);
  }));
}

module.exports = exports.default;